import React, { useState } from 'react'
import { Button, BUTTON_THEME, Input } from '@st-operations/uikit/src/v2'

import WelcomeIllustration from './welcome-illustration.svg'

import './styles.scss'

export const UNIFIED_USER_PROFILE_EVENT_FEED_TYPE = 'uup'

const UnifiedUserProfileWizardWelcome = ({ onCreate }) => {
  const [name, setName] = useState('')

  return (
    <div className="unified-user-profile-wizard-welcome__container">
      <div className="unified-user-profile-wizard-welcome__content-container">
        <WelcomeIllustration width={100} height={100} />
        <h3 className="unified-user-profile-wizard-welcome__title">
          Welcome to Unified User Profile!
        </h3>
        <span className="unified-user-profile-wizard-welcome__description">
          {`UUP helps you predict the interest of consumers using data built from analyzing people's
          daily interactions with internet content`}
        </span>
        <Input label="Name" name="name" onChange={setName} value={name} />
      </div>
      <div className="unified-user-profile-wizard-welcome__bottom-section">
        <div className="unified-user-profile-wizard-welcome__buttons-section">
          <Button
            className="unified-user-profile-wizard-welcome__start-button"
            onClick={onCreate}
            disabled={!name}
            theme={BUTTON_THEME.SECONDARY}
          >
            Cancel
          </Button>
          <Button
            className="unified-user-profile-wizard-welcome__start-button"
            onClick={() =>
              onCreate?.({
                name,
                type: UNIFIED_USER_PROFILE_EVENT_FEED_TYPE,
              })
            }
          >
            Create
          </Button>
        </div>
      </div>
    </div>
  )
}

export default UnifiedUserProfileWizardWelcome
